import React, { useEffect } from "react";

import grad from "../../../resources/certificates/grad.png";
import people from "../../../resources/camps/8-people.png";
import words from "../../../resources/assets/words.png";
import fu from "../../../resources/events/fu.png";
import stickers from "../../../resources/events/stickers.png";
import zongzi from "../../../resources/events/zongzi.png";
import lanterns from "../../../resources/events/lanterns.png";
import dumpling from "../../../resources/events/dumpling.png";
import show from "../../../resources/events/show.png";
import costumes from "../../../resources/events/costumes.jpg";
import Row from "../../common/Row";
import { useTranslation } from "react-i18next";

const News = () => {
  const { t } = useTranslation("news");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="text-white contest bg-cover bg-center items-center space-y-4 pt-20 pb-40">
        <p className="md:text-3xl text-xl text-center">
          {t("news.hero.line1")}
        </p>
        <p className="md:text-3xl text-xl text-center">
          {t("news.hero.line2")}
        </p>

        <div className="text-center md:text-lg">
          {t("news.hero.desc1")}
          <br />
          {t("news.hero.desc2")}
        </div>
      </div>

      <div className="text-center py-4 space-y-20">
        <div className="text-2xl text-emerald-600 py-4 font-bold">
          {t("news.title")}
        </div>

        {/* “我的暑假生活”作文竞赛 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("news.events.summerEssay.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.summerEssay.body1")}
              <br />
              <br />
              {t("news.events.summerEssay.body2")}
            </div>
          </div>
          <img
            src={grad}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>

        {/* 全球华语朗诵大赛 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4 md:order-2">
            <div className="text-lg text-emerald-500 font-bold text-left my-4">
              {t("news.events.recitation.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.recitation.body1")}
              <br />
              <br />
              {t("news.events.recitation.body2")}
            </div>
          </div>
          <img
            src={people}
            alt="img not found"
            className="md:w-1/3 rounded-xl md:order-1"
          />
        </Row>

        {/* 仓颉杯汉字大赛 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4">
            <div className="text-lg text-emerald-500 font-bold md:text-right text-left my-4">
              {t("news.events.cangjie.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.cangjie.body1")}
              <br />
              <br />
              {t("news.events.cangjie.body2")}
            </div>
          </div>
          <img
            src={words}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>

        {/* 除夕写福字 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4 md:order-2">
            <div className="text-lg text-emerald-500 font-bold text-left my-4">
              {t("news.events.fuWriting.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.fuWriting.body1")}
              <br />
              <br />
              {t("news.events.fuWriting.body2")}
            </div>
          </div>
          <img src={fu} alt="img not found" className="md:w-1/3 rounded-xl" />
        </Row>

        {/* 正月十五猜灯谜 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4">
            <div className="text-lg text-emerald-500 font-bold md:text-right text-left my-4">
              {t("news.events.lanternRiddles.title")}
            </div>
            <div className="text-sm md:text-right text-left">
              {t("news.events.lanternRiddles.body1")}
              <br />
              <br />
              {t("news.events.lanternRiddles.body2")}
            </div>
          </div>
          <img
            src={stickers}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>

        {/* 端午节活动 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4 md:order-2">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("news.events.dragonBoat.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.dragonBoat.body1")}
              <br />
              <br />
              {t("news.events.dragonBoat.body2")}
            </div>
          </div>
          <img
            src={zongzi}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>

        {/* 中秋汉服诗词游园 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4">
            <div className="text-lg text-emerald-500 font-bold md:text-right text-left my-4">
              {t("news.events.midAutumn.title")}
            </div>
            <div className="text-sm text-left md:text-right">
              {t("news.events.midAutumn.body1")}
              <br />
              {t("news.events.midAutumn.body2")}
              <br />
              {t("news.events.midAutumn.body3")}
              <br />
              {t("news.events.midAutumn.body4")}
              <br />
              {t("news.events.midAutumn.body5")}
            </div>
          </div>
          <img
            src={lanterns}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>

        {/* 冬至包饺子 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4 md:order-2">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("news.events.winterSolstice.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.winterSolstice.body1")}
              <br />
              <br />
              {t("news.events.winterSolstice.body2")}
            </div>
          </div>
          <img
            src={dumpling}
            alt="img not found"
            className="md:w-1/3 rounded-xl md:order-1"
          />
        </Row>

        {/* 合唱表演 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4">
            <div className="text-emerald-500 text-xl font-bold md:text-right text-left my-4">
              {t("news.events.chorus.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.chorus.body1")}
            </div>
          </div>
          <img
            src={show}
            alt="img not found"
            className="md:w-1/3 rounded-xl"
          />
        </Row>

        {/* 话剧表演 */}
        <Row>
          <div className="mb-4 md:w-1/3 space-y-4 md:order-2">
            <div className="text-emerald-500 text-xl font-bold text-left">
              {t("news.events.drama.title")}
            </div>
            <div className="text-sm text-left">
              {t("news.events.drama.body1")}
            </div>
          </div>
          <img
            src={costumes}
            alt="img not found"
            className="md:w-1/3 rounded-xl md:order-1"
          />
        </Row>
      </div>
    </div>
  );
};

export default News;
